import http from 'src/infrastructure/http'
import { parseFailedResponse, parseGoodResponse } from 'src/infrastructure/parse-axios-response'
import {
  GenericApiErrors, LocationsApiResult, LossAdjustmentPayload,
} from './LossTypes'

export const validateSupervisorBadge = async (badge: string) => {
  try {
    const resultSuccess = await http.post('/v2/recebimento/supervisao/validar', null, {
      headers: { 'user-barcode': badge },
    })
    return parseGoodResponse(resultSuccess)
  } catch (err: any) {
    return parseFailedResponse<any, any>(GenericApiErrors.Failed, err.response)
  }
}

export const getProductDescription = async (barcode: string) => {
  try {
    const resultSuccess = await http.get(`/produtos/${barcode}`)
    const response = `${resultSuccess.data.cod_produto} ${resultSuccess.data.desc_produto}`
    return parseGoodResponse<string>(response)
  } catch (err: any) {
    return parseFailedResponse<any, any>(GenericApiErrors.Failed, err.response)
  }
}

export const getProductLocation = async (barcode: string, fcId: string) => {
  try {
    const resultSuccess = await http.get(`/v2/stock-wss/product-location/${barcode}`, {
      params: {
        fulfillment_center_id: fcId,
      },
    })

    if (!resultSuccess.data.data.length) {
      return parseFailedResponse<any, any>(GenericApiErrors.Failed, 'Nenhuma localização encontrada com os parâmetros informados')
    }

    return parseGoodResponse<LocationsApiResult[]>(resultSuccess.data.data)
  } catch (err: any) {
    return parseFailedResponse<any, any>(GenericApiErrors.Failed, err.response)
  }
}

export const sendLossAdjustment = async (payload: LossAdjustmentPayload) => {
  const { batches, badge } = payload
  try {
    const resultSuccess = await http.post('/v2/adjustment/losses', batches, {
      headers: { 'user-barcode': badge },
    })
    return parseGoodResponse(resultSuccess)
  } catch (err: any) {
    return parseFailedResponse<any, any>(GenericApiErrors.Failed, err.response)
  }
}
